/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are syllables counted?`)
};

const es_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se cuentan las sílabas?`)
};

const de_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Silben gezählt?`)
};

const nl_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden lettergrepen geteld?`)
};

const fr_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les syllabes sont-elles comptées ?`)
};

const it_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono conteggiate le sillabe?`)
};

const pt_br2_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as sílabas são contadas?`)
};

const pt_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são contadas as sílabas?`)
};

const ja_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節はどのようにカウントされていますか？`)
};

const zh_ra_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节数是如何统计的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq2_q", locale)
	if (locale === "en") return en_ra_faq2_q(inputs)
	if (locale === "es") return es_ra_faq2_q(inputs)
	if (locale === "de") return de_ra_faq2_q(inputs)
	if (locale === "nl") return nl_ra_faq2_q(inputs)
	if (locale === "fr") return fr_ra_faq2_q(inputs)
	if (locale === "it") return it_ra_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq2_q(inputs)
	if (locale === "pt") return pt_ra_faq2_q(inputs)
	if (locale === "ja") return ja_ra_faq2_q(inputs)
	return zh_ra_faq2_q(inputs)
};